import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { StatusBadge } from '@/components/staffAttendance/Badges';
import { fmtTime } from '@/services/staffAttendanceApi';

const Punch = ({ p, label, testId }) => (
  <div className="flex-1" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-wide text-gray-500">{label}</div>
    {p ? (
      <div className="flex items-center gap-2"><span className="font-mono font-semibold">{fmtTime(p.time)}</span><StatusBadge status={p.status} /></div>
    ) : <span className="text-orange-600 text-sm font-medium">Not checked out</span>}
    {p?.location_name && <div className="text-[11px] text-gray-500 truncate">{p.location_name}</div>}
  </div>
);

/** Session count button in the Daily table → every In→Out session of the staff-day. */
export const SessionsButton = ({ row }) => {
  const [open, setOpen] = useState(false);
  const ss = row.sessions || [];
  if (!ss.length) return <span className="text-gray-300">—</span>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="rounded-full bg-amber-100 text-amber-800 px-3 py-1 text-xs font-bold hover:bg-amber-200 transition-colors" data-testid={`daily-sessions-btn-${row.staff_id}`}>
        {ss.length} session{ss.length > 1 ? 's' : ''}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`daily-sessions-dialog-${row.staff_id}`}>
          <DialogHeader><DialogTitle>{row.staff_name} — sessions</DialogTitle><DialogDescription>Every Check In → Check Out today; hours count approved sessions only.</DialogDescription></DialogHeader>
          <div className="space-y-2">
            {ss.map((s, i) => (
              <div key={s.in?.punch_id || i} className="rounded-lg border p-3" data-testid={`daily-session-${row.staff_id}-${i}`}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-bold text-gray-600">Session {i + 1}</span>
                  <span className="font-mono text-sm" data-testid={`daily-session-hours-${row.staff_id}-${i}`}>{s.hours != null ? `${s.hours} h` : '—'}</span>
                </div>
                <div className="flex gap-3">
                  <Punch p={s.in} label="In" testId={`daily-session-in-${row.staff_id}-${i}`} />
                  <Punch p={s.out} label="Out" testId={`daily-session-out-${row.staff_id}-${i}`} />
                </div>
              </div>
            ))}
            <div className="flex justify-between border-t pt-2 text-sm font-semibold" data-testid={`daily-sessions-total-${row.staff_id}`}>
              <span>Total (approved sessions)</span><span className="font-mono">{row.hours ?? 0} h</span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SessionsButton;
